module.exports = __webpack_public_path__ + "img/sharp_bg.32b8d640.png";